import { createContext, useContext } from "react";

const BorrowerLoanContext = createContext({
  loanId: null,
  loan: {},
  loading: true,
});

export const useBorrowerLoan = () => useContext(BorrowerLoanContext);

export default BorrowerLoanContext;
